var CivicControl = {
    me: this,

    InspectCookie: function () {

        setTimeout(function () {
            // Check if the overlay is not present and the cookie is set. If not, click the icon to show the overlay.
            if (document.getElementById('ccc-overlay') == null && document.cookie.includes("CookieControl") && !document.cookie.includes("accepted") && !document.cookie.includes("revoked")) {
                document.getElementById("ccc-icon").click();
            }
        }, 1000);
    }
}